/**
 * Resolves the best image URL for an event, defensively rejecting invalid values
 * like local file paths (C:\...), quoted strings, or empty strings.
 *
 * Preference order:
 *  1. First uploaded media item (event.media[0].url)
 *  2. event.image_url IF it looks like a valid http(s) or relative URL
 *  3. Provided fallback
 */
export function getEventThumb(event, fallback = "") {
  if (!event) return fallback;
  const mediaUrl = event.media && event.media[0] && event.media[0].url;
  if (mediaUrl && typeof mediaUrl === "string" && mediaUrl.trim()) {
    return mediaUrl.trim();
  }
  const raw = event.image_url || event.imageUrl;
  if (raw && typeof raw === "string") {
    const cleaned = raw.trim().replace(/^"|"$/g, "");
    if (/^(https?:\/\/|\/)/i.test(cleaned)) {
      return cleaned;
    }
  }
  return fallback;
}
